<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-tabs
        v-model="activeTab"
        pills
        nav-wrapper-class="mb-3"
        content-class="mt-3"
        justified
      >
        <!-- RTSP Tab -->
        <b-tab title="RTSP" active>
          <b-form>
            <b-row>
              <b-col cols="12" lg="6">
                <form-field-toggle
                  id="rtsp"
                  v-model="itemData.config.rtsp"
                  :label="$t('proxy_rtsp_server.enable_rtsp')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-select
                  id="rtspTransports"
                  v-model="itemData.config.rtspTransports"
                  :label="$t('proxy_rtsp_server.rtsp_transports')"
                  :options="rtpsTransports"
                  multiple
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-select
                  id="rtspEncryption"
                  v-model="itemData.config.rtspEncryption"
                  :label="$t('proxy_rtsp_server.rtsp_encryption')"
                  :options="rtspEncryptionOptions"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="rtspAddress"
                  v-model="itemData.config.rtspAddress"
                  :label="$t('proxy_rtsp_server.rtsp_address')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="rtspsAddress"
                  v-model="itemData.config.rtspsAddress"
                  :label="$t('proxy_rtsp_server.rtsps_address')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="rtpAddress"
                  v-model="itemData.config.rtpAddress"
                  :label="$t('proxy_rtsp_server.rtp_address')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="rtcpAddress"
                  v-model="itemData.config.rtcpAddress"
                  :label="$t('proxy_rtsp_server.rtcp_address')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="multicastIPRange"
                  v-model="itemData.config.multicastIPRange"
                  :label="$t('proxy_rtsp_server.multicast_ip_range')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="multicastRTPPort"
                  v-model="itemData.config.multicastRTPPort"
                  :label="$t('proxy_rtsp_server.multicast_rtp_port')"
                  type="number"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="multicastRTCPPort"
                  v-model="itemData.config.multicastRTCPPort"
                  :label="$t('proxy_rtsp_server.multicast_rtcp_port')"
                  type="number"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="rtspServerKey"
                  v-model="itemData.config.rtspServerKey"
                  :label="$t('proxy_rtsp_server.rtsp_server_key')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="rtspServerCert"
                  v-model="itemData.config.rtspServerCert"
                  :label="$t('proxy_rtsp_server.rtsp_server_cert')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-select
                  id="rtspAuthMethods"
                  v-model="itemData.config.rtspAuthMethods"
                  :label="$t('proxy_rtsp_server.rtsp_auth_methods')"
                  :options="[]"
                  multiple
                  taggable
                  :push-tags="true"
                  :reduce-option="(option) => option"
                  rules="required"
                />
              </b-col>
            </b-row>
          </b-form>
        </b-tab>

        <!-- RTMP Tab -->
        <b-tab title="RTMP">
          <b-form>
            <b-row>
              <b-col cols="12" lg="6">
                <form-field-toggle
                  id="rtmp"
                  v-model="itemData.config.rtmp"
                  :label="$t('proxy_rtsp_server.enable_rtmp')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="rtmpAddress"
                  v-model="itemData.config.rtmpAddress"
                  :label="$t('proxy_rtsp_server.rtmp_address')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-select
                  id="rtmpEncryption"
                  v-model="itemData.config.rtmpEncryption"
                  :label="$t('proxy_rtsp_server.rtmp_encryption')"
                  :options="rtmpEncryptionOptions"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="rtmpsAddress"
                  v-model="itemData.config.rtmpsAddress"
                  :label="$t('proxy_rtsp_server.rtmps_address')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="rtmpServerKey"
                  v-model="itemData.config.rtmpServerKey"
                  :label="$t('proxy_rtsp_server.rtmp_server_key')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="rtmpServerCert"
                  v-model="itemData.config.rtmpServerCert"
                  :label="$t('proxy_rtsp_server.rtmp_server_cert')"
                />
              </b-col>
            </b-row>
          </b-form>
        </b-tab>

        <!-- HLS Tab -->
        <b-tab title="HLS">
          <b-form>
            <b-row>
              <b-col cols="12" lg="6">
                <form-field-toggle
                  id="hls"
                  v-model="itemData.config.hls"
                  :label="$t('proxy_rtsp_server.enable_hls')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="hlsAddress"
                  v-model="itemData.config.hlsAddress"
                  :label="$t('proxy_rtsp_server.hls_address')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-toggle
                  id="hlsEncryption"
                  v-model="itemData.config.hlsEncryption"
                  :label="$t('proxy_rtsp_server.enable_hls_encryption')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="hlsServerKey"
                  v-model="itemData.config.hlsServerKey"
                  :label="$t('proxy_rtsp_server.hls_server_key')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="hlsServerCert"
                  v-model="itemData.config.hlsServerCert"
                  :label="$t('proxy_rtsp_server.hls_server_cert')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="hlsAllowOrigin"
                  v-model="itemData.config.hlsAllowOrigin"
                  :label="$t('proxy_rtsp_server.hls_allow_origin')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-select
                  id="hlsTrustedProxies"
                  v-model="itemData.config.hlsTrustedProxies"
                  :label="$t('proxy_rtsp_server.hls_trusted_proxies')"
                  :options="[]"
                  multiple
                  taggable
                  :push-tags="true"
                  :reduce-option="(option) => option"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-toggle
                  id="hlsAlwaysRemux"
                  v-model="itemData.config.hlsAlwaysRemux"
                  :label="$t('proxy_rtsp_server.hls_always_remux')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-select
                  id="hlsVariant"
                  v-model="itemData.config.hlsVariant"
                  :label="$t('proxy_rtsp_server.hls_variant')"
                  :options="hlsVariantOptions"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="hlsSegmentCount"
                  v-model="itemData.config.hlsSegmentCount"
                  :label="$t('proxy_rtsp_server.hls_segment_count')"
                  type="number"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="hlsSegmentDuration"
                  v-model="itemData.config.hlsSegmentDuration"
                  :label="$t('proxy_rtsp_server.hls_segment_duration')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="hlsPartDuration"
                  v-model="itemData.config.hlsPartDuration"
                  :label="$t('proxy_rtsp_server.hls_part_duration')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="hlsSegmentMaxSize"
                  v-model="itemData.config.hlsSegmentMaxSize"
                  :label="$t('proxy_rtsp_server.hls_segment_max_size')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="hlsDirectory"
                  v-model="itemData.config.hlsDirectory"
                  :label="$t('proxy_rtsp_server.hls_directory')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="hlsMuxerCloseAfter"
                  v-model="itemData.config.hlsMuxerCloseAfter"
                  :label="$t('proxy_rtsp_server.hls_muxer_close_after')"
                />
              </b-col>
            </b-row>
          </b-form>
        </b-tab>

        <!-- WebRTC Tab -->
        <b-tab title="WebRTC">
          <b-form>
            <b-row>
              <b-col cols="12" lg="6">
                <form-field-toggle
                  id="webrtc"
                  v-model="itemData.config.webrtc"
                  :label="$t('proxy_rtsp_server.enable_webrtc')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="webrtcAddress"
                  v-model="itemData.config.webrtcAddress"
                  :label="$t('proxy_rtsp_server.webrtc_address')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-toggle
                  id="webrtcEncryption"
                  v-model="itemData.config.webrtcEncryption"
                  :label="$t('proxy_rtsp_server.enable_webrtc_encryption')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="webrtcServerKey"
                  v-model="itemData.config.webrtcServerKey"
                  :label="$t('proxy_rtsp_server.webrtc_server_key')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="webrtcServerCert"
                  v-model="itemData.config.webrtcServerCert"
                  :label="$t('proxy_rtsp_server.webrtc_server_cert')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="webrtcAllowOrigin"
                  v-model="itemData.config.webrtcAllowOrigin"
                  :label="$t('proxy_rtsp_server.webrtc_allow_origin')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-select
                  id="webrtcTrustedProxies"
                  v-model="itemData.config.webrtcTrustedProxies"
                  :label="$t('proxy_rtsp_server.webrtc_trusted_proxies')"
                  :options="[]"
                  multiple
                  taggable
                  :push-tags="true"
                  :reduce-option="(option) => option"
                  rules="required"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="webrtcLocalUDPAddress"
                  v-model="itemData.config.webrtcLocalUDPAddress"
                  :label="$t('proxy_rtsp_server.webrtc_local_udp_address')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="webrtcLocalTCPAddress"
                  v-model="itemData.config.webrtcLocalTCPAddress"
                  :label="$t('proxy_rtsp_server.webrtc_local_tcp_address')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-toggle
                  id="webrtcIPsFromInterfaces"
                  v-model="itemData.config.webrtcIPsFromInterfaces"
                  :label="$t('proxy_rtsp_server.webrtc_ips_from_interfaces')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-select
                  id="webrtcIPsFromInterfacesList"
                  v-model="itemData.config.webrtcIPsFromInterfacesList"
                  :label="$t('proxy_rtsp_server.webrtc_ips_from_interfaces_list')"
                  :options="[]"
                  multiple
                  taggable
                  :push-tags="true"
                  :reduce-option="(option) => option"
                  rules="required"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-select
                  id="webrtcAdditionalHosts"
                  v-model="itemData.config.webrtcAdditionalHosts"
                  :label="$t('proxy_rtsp_server.webrtc_additional_hosts')"
                  :options="[]"
                  multiple
                  taggable
                  :push-tags="true"
                  :reduce-option="(option) => option"
                  rules="required"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-select
                  id="webrtcICEServers2"
                  v-model="itemData.config.webrtcICEServers2"
                  :label="$t('proxy_rtsp_server.webrtc_ice_servers_2')"
                  :options="[]"
                  multiple
                  taggable
                  :push-tags="true"
                  :reduce-option="(option) => option"
                  rules="required"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="webrtcHandshakeTimeout"
                  v-model="itemData.config.webrtcHandshakeTimeout"
                  :label="$t('proxy_rtsp_server.webrtc_handshake_timeout')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="webrtcTrackGatherTimeout"
                  v-model="itemData.config.webrtcTrackGatherTimeout"
                  :label="$t('proxy_rtsp_server.webrtc_track_gather_timeout')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="webrtcSTUNGatherTimeout"
                  v-model="itemData.config.webrtcSTUNGatherTimeout"
                  :label="$t('proxy_rtsp_server.webrtc_stun_gather_timeout')"
                />
              </b-col>
            </b-row>
          </b-form>
        </b-tab>

        <b-tab title="Playback">
          <b-form>
            <b-row>
              <b-col cols="12" lg="6">
                <form-field-toggle
                  id="playback"
                  v-model="itemData.config.playback"
                  :label="$t('proxy_rtsp_server.enable_playback')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="playbackAddress"
                  v-model="itemData.config.playbackAddress"
                  :label="$t('proxy_rtsp_server.playback_address')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-toggle
                  id="playbackEncryption"
                  v-model="itemData.config.playbackEncryption"
                  :label="$t('proxy_rtsp_server.enable_playback_encryption')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="playbackServerKey"
                  v-model="itemData.config.playbackServerKey"
                  :label="$t('proxy_rtsp_server.playback_server_key')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="playbackServerCert"
                  v-model="itemData.config.playbackServerCert"
                  :label="$t('proxy_rtsp_server.playback_server_cert')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="playbackAllowOrigin"
                  v-model="itemData.config.playbackAllowOrigin"
                  :label="$t('proxy_rtsp_server.playback_allow_origin')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-select
                  id="playbackTrustedProxies"
                  v-model="itemData.config.playbackTrustedProxies"
                  :label="$t('proxy_rtsp_server.playback_trusted_proxies')"
                  :options="[]"
                  multiple
                  taggable
                  :push-tags="true"
                  :reduce-option="(option) => option"
                />
              </b-col>
            </b-row>
          </b-form>
        </b-tab>

        <!-- SRT Tab -->
        <b-tab title="SRT">
          <b-form>
            <b-row>
              <b-col cols="12" lg="6">
                <form-field-toggle
                  id="srt"
                  v-model="itemData.config.srt"
                  :label="$t('proxy_rtsp_server.enable_srt')"
                />
              </b-col>
              <b-col cols="12" lg="6">
                <form-field-text
                  id="srtAddress"
                  v-model="itemData.config.srtAddress"
                  :label="$t('proxy_rtsp_server.srt_address')"
                />
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </validation-observer>
  </div>
</template>

<script>
import FormFieldText from "@/components/WizardModal/FormFields/FormFieldText.vue";
import FormFieldToggle from "@/components/WizardModal/FormFields/FormFieldToggle.vue";
import FormFieldSelect from "@/components/WizardModal/FormFields/FormFieldSelect.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import useRtpsServerWizard from "./useRtpsServerWizard";
import { ref } from "@vue/composition-api";

export default {
  name: "StreamingStep",
  components: {
    FormFieldText,
    FormFieldToggle,
    FormFieldSelect,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    propItemData: {
      type: Object,
      required: true,
    },
  },
  setup(props, context) {
    const activeTab = ref(0);

    // Configuración RTSP
    const rtspEncryptionOptions = ref([
      { value: "no", text: "No" },
      { value: "optional", text: "Optional" },
      { value: "strict", text: "Strict" },
    ]);

    // Configuración RTMP
    const rtmpEncryptionOptions = ref([
      { value: "no", text: "No" },
      { value: "optional", text: "Optional" },
      { value: "strict", text: "Strict" },
    ]);

    // Configuración HLS
    const hlsVariantOptions = ref([
      { value: "lowLatency", text: "Low Latency" },
      { value: "standard", text: "Standard" },
      { value: "fmp4", text: "FMP4" },
    ]);

    const rtpsTransports = ref([
      { value: "multicast", text: "Multicast" },
      { value: "tcp", text: "TCP" },
      { value: "udp", text: "UDP" },
    ]);

    const rtspAuthMethods = ref([{ value: "basic", text: "Basic" }]);

    const configDefaults = {
      playback: false,
      playbackAddress: "",
      playbackEncryption: false,
      playbackServerKey: "",
      playbackServerCert: "",
      playbackAllowOrigin: "",
      playbackTrustedProxies: [],

      rtsp: true,
      rtspTransports: [],
      rtspEncryption: "",
      rtspAddress: "",
      rtspsAddress: "",
      rtpAddress: "",
      rtcpAddress: "",
      multicastIPRange: "",
      multicastRTPPort: null,
      multicastRTCPPort: null,
      rtspServerKey: "",
      rtspServerCert: "",
      rtspAuthMethods: [],

      // RTMP defaults
      rtmp: false,
      rtmpAddress: "",
      rtmpEncryption: "",
      rtmpsAddress: "",
      rtmpServerKey: "",
      rtmpServerCert: "",

      // HLS defaults
      hls: false,
      hlsAddress: "",
      hlsEncryption: false,
      hlsServerKey: "",
      hlsServerCert: "",
      hlsAllowOrigin: "*",
      hlsTrustedProxies: [],
      hlsAlwaysRemux: false,
      hlsVariant: "",
      hlsSegmentCount: null,
      hlsSegmentDuration: "",
      hlsPartDuration: "",
      hlsSegmentMaxSize: "",
      hlsDirectory: "",
      hlsMuxerCloseAfter: "",

      // WebRTC defaults
      webrtc: false,
      webrtcAddress: "",
      webrtcEncryption: false,
      webrtcServerKey: "",
      webrtcServerCert: "",
      webrtcAllowOrigin: "",
      webrtcTrustedProxies: [],
      webrtcLocalUDPAddress: "",
      webrtcLocalTCPAddress: "",
      webrtcIPsFromInterfaces: false,
      webrtcIPsFromInterfacesList: [],
      webrtcAdditionalHosts: [],
      webrtcICEServers2: [],
      webrtcHandshakeTimeout: "",
      webrtcTrackGatherTimeout: "",
      webrtcSTUNGatherTimeout: "",

      // SRT defaults
      srt: false,
      srtAddress: "",
    };

    const { itemData, refFormObserver, getValidationState, validateStep } =
      useRtpsServerWizard(props, context, configDefaults);

    return {
      itemData,
      refFormObserver,
      getValidationState,
      validateStep,
      activeTab,
      rtspEncryptionOptions,
      rtmpEncryptionOptions,
      hlsVariantOptions,
      rtpsTransports,
      rtspAuthMethods,
    };
  },
};
</script>

<style lang="scss" scoped>
.nav-pills {
  .nav-link.active {
    background-color: #7367f0 !important;
  }
  .nav-link {
    color: #6e6b7b;
    &:hover {
      color: #7367f0;
    }
  }
}
</style>
